<template>
    <div>
        <!-- Header section -->
        <header class="header-section">
            <div class="container text-right">
                <div class="page-info">
                    <h2>Новини</h2>
                    <div class="page-links">
                        <router-link to="/">Начало</router-link>
                        <span class="active">Новини</span>
                    </div>
                </div>
            </div>
        </header>
        <!-- Header section end -->

        <div class="container mt-5">
            <div class="row">
                <div class="col-md-12 border-bottom row mb-5 pb-5">
                    <div class="col-md-1">.</div>
                    <div class="col-md-10">
                        <h2>{{ news.name }}</h2>
                        <p><i class="fa fa-calendar"></i> {{ news.createdAt | formatDate }}</p>
                        <router-link v-if="userLogedIn" class="btn-lg btn-primary" :to="{name: 'newsEdit', params: { id: $route.params.id }}">РЕДАКТИРАНЕ</router-link>
                        <div class="news-image-container mt-3">
                            <img :src="news.image" alt="" class="card-img-top">                        </div>
                        <p class="mt-4" v-html="news.description"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { db } from '../../firebase';

    export default {
        data() {
            return {
                news: {
                }
            }
        },
        computed: {
            userLogedIn () {
                return this.$store.getters.user
            }
        },
        created() {
            let dbRef = db.collection('news').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.news = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        }
    }
</script>
